import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import {
  Toolbar,
  ThemeProvider,
  mediaSizes,
  darkTheme
} from '@material-dev/thread';

const CustomToolbar = styled(Toolbar)`
  background-color: ${props => props.bgColor};
  ${props => props.twoLineOnMobile ? css`
    @media (max-width: ${mediaSizes.sm}px) {
      flex-direction: column;
      flex-flow: column-reverse;
      align-items: start;
      padding: 8px 8px 16px 8px;
      min-height: 100px;
    }
  ` : null}
`;

const ModalToolbar = props => (
  <ThemeProvider theme={props.theme}>
    <CustomToolbar {...props}>
      {props.children}
    </CustomToolbar>
  </ThemeProvider>
);

ModalToolbar.propTypes = {
  theme: PropTypes.object,
  bgColor: PropTypes.string,
  children: PropTypes.node
};

ModalToolbar.defaultProps = {
  theme: darkTheme,
  bgColor: '#FF8055'
};

export default ModalToolbar;



// WEBPACK FOOTER //
// ./src/app/admin/components/ModalToolbar/index.js